// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-training-score-text-top>.row[data-v-c82267d4]{padding:.8rem 0}.training-knowledge[data-v-c82267d4]{color:#2cb774;font-weight:700;font-size:1.2rem}.remaining-levels[data-v-c82267d4]{padding:0 .2rem}.green[data-v-c82267d4]{color:#2cb774}.icon-shoucang[data-v-c82267d4]{color:#ffc13b}", ""]);
// Exports
module.exports = exports;
